import * as React from "react";

import {
  VIEWBOX_WIDTH,
  VIEWBOX_HEIGHT,
  VIEWBOX_HEIGHT_HALF,
  VIEWBOX_CENTER_X,
  VIEWBOX_CENTER_Y,
} from "./constants";
import Path from "./Path";
import "./styles.css";

export default function CircularProgressbar({
  background = false,
  backgroundPadding = 0,
  circleRatio = 1,
  classes = {
    root: "CircularProgressbar",
    trail: "CircularProgressbar-trail",
    path: "CircularProgressbar-path",
    text: "CircularProgressbar-text",
    background: "CircularProgressbar-background",
  },
  counterClockwise = false,
  className = "",
  maxValue = 100,
  minValue = 0,
  trailStrokeWidth = 8,
  pathStrokeWidth = 8,
  styles = {
    root: {},
    trail: {},
    path: {},
    text: {},
    background: {},
  },
  text = "",
  value = 0,
}) {
  const getBackgroundPadding = () => {
    if (!background) {
      // Don't add padding if not displaying background
      return 0;
    }
    return backgroundPadding;
  };

  const getPathRadius = () => {
    // The radius of the path is defined to be in the middle, so in order for the path to
    // fit perfectly inside the 100x100 viewBox, need to subtract half the strokeWidth
    return VIEWBOX_HEIGHT_HALF - pathStrokeWidth / 2 - getBackgroundPadding();
  };

  // Ratio of path length to trail length, as a value between 0 and 1
  const getPathRatio = () => {
    const boundedValue = Math.min(Math.max(value, minValue), maxValue);
    return (boundedValue - minValue) / (maxValue - minValue);
  };

  const pathRadius = getPathRadius();
  const pathRatio = getPathRatio();
  return (
    <svg
      className={`${classes.root} ${className}`}
      style={styles.root}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      data-test-id="CircularProgressbar"
    >
      <Path
        className={classes.trail}
        counterClockwise={counterClockwise}
        dashRatio={circleRatio}
        pathRadius={pathRadius}
        strokeWidth={trailStrokeWidth}
        style={styles.trail}
      />

      <Path
        className={classes.path}
        counterClockwise={counterClockwise}
        dashRatio={pathRatio * circleRatio}
        pathRadius={pathRadius}
        strokeWidth={pathStrokeWidth}
        style={styles.path}
      />

      {text ? (
        <text
          className={classes.text}
          style={styles.text}
          x={VIEWBOX_CENTER_X}
          y={VIEWBOX_CENTER_Y}
        >
          {text}
        </text>
      ) : null}
    </svg>
  );
}
